import { isConnected } from './pubSubStatusComparators';
export const isClientReady = isConnected;